<div class="mb-4">
   <h4 class="sidebar-title mb-3"> Tags </h4>
</div>
<a href="javascript:void(0)" class="btn btn-outline-secondary btn-sm mb-2 mx-1" *ngFor="let tag of tags"> {{tag?.value}}</a>
